import React, { Component } from 'react'
import { Grid, Hidden, Button, Typography, Icon, IconButton } from '@material-ui/core';
import moment from 'moment';

export default class ResumeSearch extends Component {



    render() {
        const { searchData } = this.props
        const travelersCount = searchData[0]?.travelers?.length || searchData[1]?.travelers?.length || 0;
        return (
            <Grid container spacing={1}>
                <Hidden smDown>
                    <Grid item lg={2}>
                        <Typography variant="h2" className="h3 title">
                            <span className="icon icon-tren"></span> Tu búsqueda
                        </Typography>
                    </Grid>
                </Hidden>
                {searchData[0] && searchData[0].dictionary ?
                    <Grid item xs={10} sm={9}>
                        {/* if tickets */}
                        <ul className="list-unstyled list-inline resume-search">
                            {searchData.map((search, i) => {
                                return (
                                    <li className="list-inline-item item-roundtrip" key={i}>
                                        <div className="item-search detail-tramo">
                                            <span className="label-input visible-lg">Tramo {i + 1}</span>
                                            <span className="item-detail">{search.dictionary.leg.origin.label}</span>
                                            <span className="icon-arrow"> - </span>
                                            <span className="item-detail item-detail-arrival">{search.dictionary.leg.destination.label}</span>
                                        </div>
                                    </li>)
                            })}
                            <li className="list-inline-item item-roundtrip">
                                <div className="item-search guests-search">
                                    <span className="label-input visible-lg ">N° de pasajeros</span>
                                    <span className="item-detail">{travelersCount > 0 ? `${travelersCount} pasajero` : 'N/A'}</span>
                                </div>
                            </li>
                        </ul>
                    </Grid>
                    :
                    <Grid item xs={10} sm={9}>
                        {/* if passes */}
                        <ul className="list-unstyled list-inline resume-search">
                            <li className="list-inline-item item-roundtrip">
                                <div className="item-search detail-tramo">
                                    <span className="label-input ">Destino </span>
                                    <span className="item-detail">{searchData.descriptionCode.description}</span>
                                </div>
                            </li>
                            <li className="list-inline-item item-roundtrip">
                                <div className="item-search guests-search">
                                    <span className="label-input visible-lg ">Fecha</span>
                                    <span className="item-detail">{moment(searchData.search.validityStartDate).locale('es').format('dddd, Do MMM YY').replace('º', '')}</span>
                                </div>
                            </li>
                        </ul>
                    </Grid>

                }
                <Grid item xs={2} sm={1}>
                    <Hidden smDown>
                        <Button className="btn-outlined-white btn-modify" onClick={this.props.handleExpandClick} aria-expanded={this.props.expanded} variant="outlined" fullWidth >
                            {this.props.expanded ? 'Cancelar' : 'Modificar'}
                        </Button>
                    </Hidden>
                    <Hidden mdUp>
                        <IconButton aria-label={this.props.expanded ? 'Cancelar' : 'Modificar'} onClick={this.props.handleExpandClick} aria-expanded={this.props.expanded} >
                            {this.props.expanded ? (
                                <Icon>check</Icon>
                            ) : (
                                <Icon>create</Icon>
                            )}

                        </IconButton>
                    </Hidden>

                </Grid>
            </Grid>
        )
    }
}
